export const AccountType = {
  INDIVIDUAL_STUDENT: "Individual Student",
  SCHOOL_ACCOUNT: "School Account",
  STUDENT: "School Student",
  STAFF: "STAFF",
  TEACHER: "School Teacher",
  ANONYMOUSE_USER: "Anonymouse User",
  FRANCHISE_USER: "Franchise User",
  FRANCHISE_EMPLOYEE: "Franchise Employee",
  STAFF_AND_SCHOOL_ACCOUNT: "STAFF and School Account",
};

export const exerciseType = {
  WRITING_TASK: "Writing Task",
  READING_TASK: "Reading Task",
  GRAMMAR_TASK: "Grammar Task",
  LISTENING_TASK: "Listening Task",
  PRONUNCIATION_TASK: "Pronunciation Task",
  VOCABULARY_TASK: "Vocabulary Task",
  SPEAKING_TASK: "Speaking Task"
};

export const assessmentFlow = {
  SEQUENTIAL: "Sequential",
  SEQUENTIAL_EARLY_STOP: "SequentialEarlyStop",
  FORKING_LOGIC: "ForkingLogic",
};

export const assessmentType = {
  PLACEMENT: "Placement",
  LEVEL: "Level",
  READING: "Reading",
  LISTENING: "Listening",
  SPEAKING: "Speaking",
};

export const assignmentStatus = {
  New: "New",
  INPROGRESS: "In progress",
  TASK_COMPLETED: "Task completed",
  TASK_NOT_COMPLETED: "Task not completed",
  SUBMITTED_LATE: "Submitted late",
  SUBMISSION_FAILED: "Submission Failed",
  Scheduled: "Scheduled",
};

export const questionType = {
  RadioBox: 'Single choice question',
  CheckBox: 'Multiple Choices question',
  FillInBlank: 'Fill in the missing word',
  FillInBlankChoices: 'Choose the correct word',
  DragAndDropCrossMatch: 'Drag And Drop question',
};

export const disableFields = {
  THEME: 'Theme',
  VOCAB: 'Vocabulary',
  GRAMMAR: 'Grammar',
  NO_OF_QUESTIONS: 'Number of Questions',
  NO_OF_OPTIONS: 'Number of Options',
  ADVANCE_SETTINGS: 'Additional settings',
  SUGGESTED_WORDS: 'Suggested Words',
  FORMALITY: 'Formality',
  TASK_STYLE: 'Task Style',
  SAMPLE_VOICES: 'Sample Voices'
};
export const NoofQuestions = [1,2,3,4,5,6,7,8,9,10]
export const ExpandNoofQuestions = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]
export const formality = ["Informal","Neutral","Formal"]
export const NoofOptions = [2,3,4]
export const DirectSubmission = "without warning"

export const TestStatus = {
  Prepare: "Preparing",
  Read: "Reading",
  INFO_PREPARE: "Ques Info Prepare time",
  PLAY_QUES: "Read Question",
}

export const SpeakingType = {
  READ_TEXT: "Read text aloud",
  DESCRIBE_PHOTO: "Describe a photo",
  RESPOND_QUESTION: "Respond to question",
  RESPOND_INFO_QUESTION: "Respond to question with information",
  AUDIO_QUESTION: "Audio question",
};